import React from 'react';
import PropTypes from 'prop-types';
import DesktopStep from './DesktopStep';
import Dictionary from '../../model/Dictionary';
import PrevStep from './PrevStep';
import NextStep from './NextStep';
import Exit from './Exit';

const DesktopNavigation = ({ navigation, currentLocation, onClick, prevStep, nextStep, exit }) => (
  <div className='desktop-navigation'>
    <div className='desktop-navigation-left'>
      <Exit label={Dictionary.step.exit} exit={exit} />
    </div>

    <div className='desktop-navigation-stepper'>
      {navigation.map((step, index) => (
        <DesktopStep
          key={`navigation-desktop-step-${step.id}-${index}`}
          stepNum={index + 1}
          stepDescription={Dictionary.step[ step.id.toLowerCase() ]}
          stepId={step.id.toLowerCase()}
          onClick={onClick}
          enabled={step.enabled}
          active={currentLocation.indexOf(step.id.toLowerCase()) === 1}
        />
      ))}
    </div>

    <div className='desktop-navigation-right'>
      <PrevStep
        className='desktop-prev'
        label={Dictionary.step.prev}
        prevStep={prevStep ? Dictionary.step[ prevStep.id.toLowerCase() ] : ''}
        step={prevStep}
        onClick={onClick}
      />
      <NextStep
        className='desktop-next'
        label={Dictionary.step.next}
        nextStep={nextStep ? Dictionary.step[ nextStep.id.toLowerCase() ] : ''}
        step={nextStep}
        onClick={onClick}
      />
    </div>
  </div>
);

DesktopNavigation.propTypes = {
  navigation: PropTypes.arrayOf(PropTypes.object),
  currentLocation: PropTypes.string,
  exit: PropTypes.string,
  onClick: PropTypes.func,
  prevStep: PropTypes.object,
  nextStep: PropTypes.object,
};

export default DesktopNavigation;



// WEBPACK FOOTER //
// ./src/components/navigation/DesktopNavigation.js